import { ERROR_CODE } from "../../utils/constant/constant";

export const getEmailOTPCounterStatus = async (email: string) => {
  const responseObj = { isEligible: true };
  

  try {
    const url = `${process.env.REACT_APP_GET_COUNTER_STATUS_API ?? 'https://npr-custom-wrapper.api.pens.com/v1/emailOTP/getcounterstatus'}`
    const response = await fetch(`${url}?email=${encodeURIComponent(email)}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key' : process.env.REACT_APP_NP_API_KEY_CLIENT_JS_2 ?? ''
      },
    });

    const result = await response.json();

    if (!response.ok) {
        throw { errorCode: ERROR_CODE.GENERIC_ERROR }
    }

    if (result?.isEligible === false) {
      responseObj.isEligible = false;
    }

  } catch (error) {
    throw { errorCode: ERROR_CODE.GENERIC_ERROR }
  }

  return responseObj;
};